export const FOR_COMPANIES_PLUSES_LIST = [{
  header: 'Индивидуальные программы обучения',
  text: 'Мы&nbsp;адаптируем курс под нужды вашей команды. Больше времени на&nbsp;переговоры? Или нужен акцент на&nbsp;письменных коммуникациях? Мы&nbsp;учитываем специфику вашей работы.'
}, {
  header: 'Гибкий формат занятий ',
  text: 'Онлайн-уроки в&nbsp;удобное для ваших сотрудников время, чтобы обучение не&nbsp;мешало их&nbsp;рабочему процессу.'
}, {
  header: 'Опытные преподаватели',
  text: 'Эксперты с международным опытом помогут вашей команде овладеть английским, ориентированным на реальные задачи бизнеса.'
}, {
  header: 'Отчеты о прогрессе',
  text: 'Регулярная оценка успехов каждого сотрудника и&nbsp;рекомендации для дальнейшего обучения.'
}, {
  header: 'Увеличение эффективности работы',
  text: 'Уверенное владение английским позволит вашей команде вести переговоры, решать задачи и&nbsp;взаимодействовать с&nbsp;международными клиентами без языковых барьеров.'
}];